import { createApp } from "vue";
import {
	createRouter,
	createWebHistory,
	createWebHashHistory,
} from "vue-router";
import Login from "@/views/Login.vue";
import Register from "@/views/Register.vue";
import HomePage from "@/views/HomePage.vue";
import Dashboard from "@/views/Dashboard.vue";
import Settings from "@/views/Settings.vue";
import Profile from "@/views/Profile.vue";
import Hosts from "@/views/Hosts.vue";
import Keys from "@/views/Keys.vue";
import Logs from "@/views/Logs.vue";
import ResponseCode from "@/views/ResponseCode.vue";
import RulesByAmount from "@/views/RulesByAmount.vue";
import Terminals from "@/views/Terminals.vue";
import Transactions from "@/views/Transactions.vue";
import UserManagment from "@/views/UserManagment.vue";
import Protocols from "@/views/Protocols.vue";
import Graphs from "@/views/Graphs.vue";

const router = new createRouter({
	linkActiveClass: "active",
	mode: "hash",
	history: createWebHistory(),
	routes: [
		{
			path: "/",
			component: HomePage,
			children: [
				//HomePage's <router-view>
				{ path: "/dashboard", component: Dashboard },
				{ path: "/logs", component: Logs },
				{ path: "/settings", component: Settings },
				{ path: "/hosts", component: Hosts },
				{ path: "/keys", component: Keys },
				{ path: "/profile", component: Profile },
				{ path: "/responscode", component: ResponseCode },
				{ path: "/rulesbyamount", component: RulesByAmount },
				{ path: "/terminals", component: Terminals },
				{ path: "/transactions", component: Transactions },
				{ path: "/usermanagment", component: UserManagment },
				{ path: "/protocol", component: Protocols },
				{ path: "/graphs", component: Graphs },
				{ path: "/", component: Dashboard },
			],
		},
		{ path: "/login", component: Login },
		{ path: "/register", component: Register },
		// otherwise redirect to home
		{ path: "/:pathMatch(.*)*", redirect: "/" },
		{ path: "/:pathMatch(.*)", redirect: "/" },
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
			return { x: 0, y: 0 };
		}
	},
});

router.beforeEach((to, from, next) => {
	// redirect to login page if not logged in and trying to access a restricted page
	const publicPages = ["/login", "/register"];
	const authRequired = !publicPages.includes(to.path);
	let loggedIn = null;
	if (typeof localStorage !== "undefined") {
		try {
			JSON.parse(localStorage.getItem("user"));
		} catch (e) {
			localStorage.removeItem("user");
		}
	} else {
		// localStorage is not available
	}
	loggedIn = localStorage.getItem("user");
	if (authRequired && !loggedIn) {
		return next("/login");
	}

	next();
});

createApp().use(router);

export default router;
